import { SIZES } from "@frontend/styles/constants";

export const MENU_VARIANTS = ["default", "inverse", "dense"] as const;

export const ARROW_SIZES: Record<(typeof SIZES)[number], number> = {
  sm: 6,
  md: 8,
  lg: 10,
};

export const MENU_TAG_NAME = "menu" as const;

export const MENU_TRIGGER_TAG_NAME = "menu-trigger" as const;

export const MENU_CONTENT_TAG_NAME = "menu-content" as const;

export const MENU_ITEM_TAG_NAME = "menu-item" as const;
